/*
 * @Author: tianxiangyu tianxiangyu@abc.com
 * @Date: 2023-05-18 14:17:51
 * @LastEditors: tianxiangyu tianxiangyu@abc.com
 * @LastEditTime: 2023-05-19 10:07:20
 * @FilePath: /platform/src/api/oaTemplate.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import utils from "@/eco-ui-util.js";
import req from "@/request.js";
const business = req.getContext().business;
export default {
  getPaTemplate() {
    return new Promise(resolve => {
      req
        .request({
          url: `${business}/oa/oa_task_template/tree`
        })
        .then(response => {
          resolve(utils.tile2nest(response.data.value));
        });
    });
  },
  delOaTemplate(id) {
    return new Promise(resolve => {
      req
        .request({
          url: `${business}/oa/oa_task_template/${id}`,
          method: "DELETE"
        })
        .then(res => {
          resolve(res.data);
        });
    });
  },
  getTemplateList(id) {
    return new Promise(resolve => {
      req
        .request({
          url: `${business}/oa/oa_task_template/queryTreeById/${id}`,
          method: "GET"
        })
        .then(res => {
          resolve(res.data);
        });
    });
  }
};
